import { useMemo } from "react";
import { useContentEditingSafe } from "./ContentEditingContext";
import { categories, type StoreCategory } from "../../storeSiteConfig";

/** Content key that stores JSON array of hidden category slugs */
export const HIDDEN_CATS_KEY = "category-bar:hidden-slugs";

/**
 * Returns only the categories that haven't been hidden via edit mode.
 * Use this hook everywhere categories are displayed to keep them in sync.
 */
export function useVisibleCategories(): StoreCategory[] {
  const ctx = useContentEditingSafe();

  return useMemo(() => {
    if (!ctx) return categories;
    try {
      const raw = ctx.getContent(HIDDEN_CATS_KEY, "[]");
      const hidden: string[] = JSON.parse(raw);
      if (!Array.isArray(hidden) || hidden.length === 0) return categories;
      return categories.filter((cat) => !hidden.includes(cat.slug));
    } catch {
      return categories;
    }
  }, [ctx]);
}
